import axios from "axios";
import { BASE_URL } from "../config/api_collection";
import { FLOW_TYPE, NOTIFICATION_MESSAGE_TYPE } from "../constants/variables";
import apolloClient from "../graphql";
import { CHECKIN_RETRIEVE } from "../graphql/checkinQueries";
import { getToken } from "../helper/token";
import { EventType, loggingUserActivities } from "../services/loggingUserActivities/loggingUserActivities";
import { displayNotificationMessage } from "../services/notificationMessagePopup";
import { trackUserActivity } from "@/services/trackUserActivity";
import { actionType, eventName } from "constants/events/eventName";

const CHECKIN = `${BASE_URL}/api/ibe/booking/checkin`;
const CHECKIN_V3 = `${BASE_URL}/api/ibe/booking/v3/checkin`;
const DECRYPT = `${BASE_URL}/api/ibe/booking/retrieve`;

export async function CheckinData(lastName: string, recordLocator: string) {
  const LastName = lastName.includes("@") ? null : lastName;
  const Email = lastName.includes("@") ? lastName : null;
  loggingUserActivities({
    event: "Check in retrieve pnr",
    pnr: recordLocator,
    lastName: LastName,
    email: Email
  }, FLOW_TYPE.CHECK_IN, EventType.EVENT, recordLocator);
  const response = await apolloClient
    .query({
      query: CHECKIN_RETRIEVE,
      variables: {
        request: {
          lastName: LastName,
          recordLocator: `${recordLocator}`,
          emailAddress: Email
        }
      },
      fetchPolicy: "no-cache"
    })
    .catch((err) => {
      console.warn(err);
      loggingUserActivities("Exception In Check-In Initialization", FLOW_TYPE.CHECK_IN, EventType.FAIL, recordLocator, err as Error);
    });

  return response;
}

export const checkinForSegments = async (requestBody: any) => {
  try {
    const token = localStorage.getItem("token");
    const headers: any = {
      Authorization: token
    };
    const checkin = await axios.put(CHECKIN, requestBody, { headers });
    return checkin;
  } catch (err) {
    displayNotificationMessage(NOTIFICATION_MESSAGE_TYPE.ERROR, "Check-in failed");
    return false;
  }
};

export const decryptCheckinData = async (requestObject: object) => {
  try {
    const tokenHeaders = await getToken();
    const headers: any = tokenHeaders;
    const decryptedData = await axios.get(DECRYPT, {
      params: requestObject,
      headers
    });
    return decryptedData;
  } catch (err) {
    displayNotificationMessage(NOTIFICATION_MESSAGE_TYPE.ERROR, "Check-in failed");
    return false;
  }
};

export const checkForAutoCheckinAPICall = async (requestBody: any) => {
  try {
    const token = localStorage.getItem("token");
    const headers: any = {
      Authorization: token
    };
    const checkin = await axios.post(CHECKIN_V3, requestBody, { headers });
    return checkin;
  } catch (err) {
    displayNotificationMessage(NOTIFICATION_MESSAGE_TYPE.ERROR, "Check-in failed");
    return false;
  }
};

export const setTrackUserActivityCheckIn = async (currentBookingInState: any, userDetails: any ) => {
  const { firstName, lastName, email, recordLocator } = userDetails;

  trackUserActivity({
    actionType: actionType.CLICK,
    eventName: eventName.RETRIVE_BOOKING_WITH_PNR,
    details: {
      userInput: {
        pnrDetails: recordLocator,
        email: email,
        lastName: lastName
      },
      pageType: "CHECK_IN",
      currentBookingInState: currentBookingInState,
      source: "Home Page",
      selectedCurrency: currentBookingInState?.currencyCode 
    }
  });
}